import TagManager from "react-gtm-module";

/**
 * Send a custom event to Google Tag Manager
 * @param {string} eventName - The name of the event (e.g., 'form_submit', 'button_click')
 * @param {object} eventData - Additional data to send with the event
 *
 * @example
 * sendGTMEvent('form_submit', {
 *   form_name: 'contact_form',
 *   step: 'personal_info'
 * });
 */
export const sendGTMEvent = (eventName, eventData = {}) => {
  TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      ...eventData,
    },
  });
};

/**
 * Track a form submission in GTM
 * @param {string} formName - The name/identifier of the form
 * @param {object} additionalData - Any additional data to include
 */
export const trackFormSubmit = (formName, additionalData = {}) => {
  sendGTMEvent("form_submit", {
    form_name: formName,
    ...additionalData,
  });
};

/**
 * Track a button click in GTM
 * @param {string} buttonName - The name/identifier of the button
 * @param {object} additionalData - Any additional data to include
 */
export const trackButtonClick = (buttonName, additionalData = {}) => {
  sendGTMEvent("button_click", {
    button_name: buttonName,
    ...additionalData,
  });
};

/**
 * Track an error in GTM
 * @param {string} errorMessage - The error message
 * @param {object} additionalData - Any additional data to include
 */
export const trackError = (errorMessage, additionalData = {}) => {
  sendGTMEvent("error", {
    error_message: errorMessage,
    ...additionalData,
  });
};
